/***       invoiceRecord    发票申请记录    ***/
<template>
  <div class="invoiceRecord">
    <pull-to :top-load-method="topRefreshFn" :bottom-load-method="bottomRefreshFn">
      <xk-invoice-record-mod :time="'2017.01 08:20'"
                             v-for="(item,index) in content"
                             :sum="'529.00'"
                             :memo="'专车'"
                             :type="'纸质发票'"
                             :key="index"
                             :state="1">
      </xk-invoice-record-mod>
    </pull-to>
    <xk-upload-mod :state="loadState"></xk-upload-mod>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import XkInvoiceRecordMod from '../../module/invoiceRecordMod/src/invoiceRecordMod.vue'
  import XkUploadMod from '../../module/uploadMod/src/uploadMod.vue'
  import PullTo from 'vue-pull-to'

  export default {
    components: {
      XkUploadMod,
      PullTo,
      XkInvoiceRecordMod
    },
    name: 'invoiceRecord',
    computed: {
      ...mapGetters({
        loginData: 'loginData',
        invoiceRecord: 'invoiceRecord'
      })
    },
    data () {
      return {
        page: 0,
        rows: 10,
        content: [],
        total: 10,
        loadState: false
      }
    },
    watch: {},
    methods: {
      loadDataButFn: function (loaded, type) { //  获取更多订单
        let that = this
        // that.loadState = true
        that.$store.dispatch('getInvoicesApply', {
          'order_type': 'daijia',
          'customer_id': that.loginData.passenger.id,
          'page': that.page,
          'limit': that.rows,
          fn: (data) => {
            if (data) {
              that.loadState = false
              let Data = data.invoicesApplys
              let content = that.content
              if (type !== 'push') {
                content = []
              }
              Data.forEach((row) => {
                content.push(row)
              })
              that.content = content
              if (loaded) {
                loaded('done')
              }
            }
          }
        })
      },
      bottomRefreshFn (loaded) {
        this.total = 1
        this.loadDataButFn(loaded)
      },
      topRefreshFn (loaded) {
        this.page++
        this.loadDataButFn(loaded, 'push')
      }
    },
    mounted: function () {
      let that = this
      that.$store.dispatch('checkLogin', (state) => {
        if (state) {
          that.loadDataButFn()
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .invoiceRecord {
    width: 100%;
    box-sizing: border-box;
    height: 100vh;
    .loadDataBut {
      box-sizing: border-box;
      width: 100%;
      line-height: 3.5rem;
      span {
        width: 100%;
        background-color: #fff;
        border-radius: 0.333rem;
        text-align: center;
      }
    }
    .invoiceRecordMod {
      margin: 1rem;
      width: calc(~'100% - 2rem');
    }
    .wujilv {
      height: 40vh;
      padding-top: 30vh;
      h2{
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// invoiceRecord.vue?2f1098ea